import React from 'react';
import PropTypes from "prop-types"
import { Button } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { Breadcrumb as Crumb } from "semantic-ui-react"
import historyStore from "stores/historyStore"

import "./Breadcrumbs.scss"
import _ from "lodash"


export default class Breadcrumbs extends React.Component {

  render() {
    const { history } = historyStore
    const length = history.length

    return (<div>
      <Crumb>
        {history.map( ( station, index ) => {
          console.log( "ii", index, length )
          const lastItem = (1 + index) === length
          return (
            [
              <Crumb.Section as={Link} to={station.link} key={station.content} link>{station.content}</Crumb.Section>,
              lastItem ? null : <Crumb.Divider key={station.content + "_divider"} icon="right angle"/>
            ]
          )
        } )}
      </Crumb>
   </div>)
  }
}

export const BreadcrumbsOld = ( { path } ) => {
  let breadcrumb = []
  _.forEach( path, ( segment, index ) => {
    let isLast = (index == path.length - 1)
    breadcrumb.push( <li key={index}><Link to={segment.link}><Button type="link">{segment.title}</Button></Link></li> )
    if ( !isLast ) {
      breadcrumb.push( <li key={`${index}-divider`}><i className="icon-angle-right"></i></li> )
    }
  } )

  return (
    <div className="breadcrumbs padding-top padding-bottom">
      <ul className="breadcrumb-list">
        {breadcrumb}
      </ul>
    </div>
  )
}

Breadcrumbs.propTypes = {
  path: PropTypes.array
}




// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.js